import { createAction, props } from '@ngrx/store';
export const loadUserCredits = createAction(
  '[Credit] Load User Credits',
  props<{ userId: string }>()
);
export const loadUserCreditsSuccess = createAction(
  '[Credit] Load User Credits Success',
  props<{ credits: any}>()
);
export const loadUserCreditsFailure = createAction(
  '[Credit] Load User Credits Failure',
  props<{ error: any }>()
);
export const updateUserCredits = createAction(
  '[Credit] Update User Credits',
  props<{ credits: number }>()
);
export const updateUserCreditsSuccess = createAction(
  '[Credit] Update User Credits Success',
  props<{ credits: number }>()
);
export const updateUserCreditsFailure = createAction(
  '[Credit] Update User Credits Failure',
  props<{ error: any }>()
);
